module.exports = __webpack_public_path__ + "static/media/top-logo.5fd40683.svg";